import { Banner, Link } from '@stitch-fix/mode-react';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';

export type BannerType =
  | 'resend_confirmation'
  | 'link_expired'
  | 'email_not_found'
  | 'client_inactive'
  | 'account_inactive'
  | 'unknown_error'
  | 'error';

export const BannerWrapper = () => {
  const [state, send] = SignInMachineContext.useActor();

  if (state.context.banner) {
    const banners = {
      resend_confirmation: {
        message: 'We resent a new sign in link.',
        variant: 'info-border',
      },
      link_expired: {
        message:
          'Sorry, something went wrong with that sign in link. Please try again.',
        variant: 'error-border',
      },
      email_not_found: {
        message: (
          <>
            We couldn&apos;t find an account with that email. Try again or{' '}
            <Link href="/signup">create an account</Link>
          </>
        ),
        variant: 'error-border',
      },
      client_inactive: {
        message: (
          <>
            We are experiencing technical difficulties. Please try again later.{' '}
            <br />
            For immediate support contact{' '}
            <Link
              href="https://support.stitchfix.com/support/tickets/new?ticket_form=ask_a_question"
              target="_blank"
            >
              Client Support
            </Link>
            .
          </>
        ),
        variant: 'error-border',
      },
      account_inactive: {
        message: (
          <>
            We are experiencing technical difficulties. Please try again later.{' '}
            <br />
            For immediate support contact{' '}
            <Link
              href="https://support.stitchfix.com/support/tickets/new?ticket_form=ask_a_question"
              target="_blank"
            >
              Client Support
            </Link>
            .
          </>
        ),
        variant: 'error-border',
      },
      unknown_error: {
        message: 'Unknown error. Please try again.',
        variant: 'error-border',
      },
      error: {
        message:
          state.context.banner.message || 'Unknown error. Please try again.',
        variant: 'error-border',
      },
    } as const;
    const banner = banners[state.context.banner.bannerType];

    return (
      <Banner
        variant={banner.variant}
        onClose={() => send('CLOSE_BANNER')}
        mb={1}
      >
        {banner.message}
      </Banner>
    );
  }

  return null;
};
